import { messages } from './messages';

export const Country = {
  messageDescriptor: messages.country,
  id: 'country',
};
